import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { brandName } from "../../../../Constants/content";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
  textGreyColor,
  textLightColor,
} from "../../../../Constants/Colors";

import ErrorAlert from "../../../../Components/ErrorAlert";
import GetInTouch from "../../../../Components/GetInTouch";
import { useGetServicesQuery } from "../../../../redux/api/ServicesApi/servicesApi";
import { Link, useNavigate } from "react-router-dom";

const ServicesSection = () => {
  const navigate = useNavigate();
  const [hoverIndex, setHoverIndex] = useState(null);

  // Use the services API hook
  const { data, error, isLoading } = useGetServicesQuery({
    limit: 4,
    status: true,
    sortBy: "display_order",
    order: "asc",
  });

  // Handle loading state
  if (isLoading) {
    return (
      <section
        style={{
          backgroundColor: primaryColor,
          color: textLightColor,
          padding: "60px 0",
        }}
      >
        <Container>
          <div className="text-center">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  // Handle error state
  if (error) {
    return (
      <>
        <ErrorAlert
          message="Unable to fetch services. Please try again later."
          iconSize={30}
        />
      </>
    );
  }

  const services = data?.services;

  console.log("services", services.defaultText);

  return (
    <section
      style={{
        backgroundColor: primaryColor,
        color: textLightColor,
        padding: "60px 0",
      }}
    >
      <Container>
        <Row className="mb-4 mx-auto justify-content-center">
          <Col md={8} lg={8}>
            <p
              className="text-uppercase text-white mb-1"
              style={{ fontSize: "14px" }}
            >
              Our Services
            </p>
            <h2 className="fw-bold text-white">
              Boost <span style={{ color: secondaryColor }}>Your Brand</span>
              <br />
              With Our Expertise
            </h2>
            <p
              style={{
                fontSize: "14px",
                color: textLightColor,
                textAlign: "justify",
              }}
            >
              At {brandName}, we create digital experiences that enhance your
              brand and inspire your audience. Our dedicated team delivers
              innovative solutions, driven by your vision.
            </p>
          </Col>
          <Col md={4} lg={3} className="text-md-center text-end">
            <Button
              className="rounded-pill "
              onClick={() => navigate("/services")}
              style={{
                backgroundColor: secondaryColor,
                color: textDarkColor,
                fontWeight: "600",
                border: "none",
              }}
            >
              View All Services →
            </Button>
          </Col>
        </Row>

        <Row className="g-4 px-2 mb-5">
          {services.map((service, index) => (
            <Col md={6} key={service.id}>
              <Card
                className={`border-0 shadow card-hover-animated h-100 ${
                  hoverIndex === index ? "hovered" : ""
                }`}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  borderRadius: "16px",
                  width: "100%",
                  "--hover-color": secondaryColor,
                }}
              >
                <Card.Body className="p-4">
                  <Row className="align-items-center h-100">
                    <Col xs={8} className="d-flex flex-column justify-content-between h-100">
                      <div>
                        <div className="d-flex align-items-center mb-2">
                          <h3
                            style={{
                              color: hoverIndex === index ? textGreyColor : primaryColor,
                              fontWeight: "bold",
                              margin: 0,
                              marginRight: "10px",
                            }}
                          >
                            {index + 1}.
                          </h3>
                        </div>
                        <h5
                          style={{
                            color: hoverIndex === index ? textGreyColor : primaryColor,
                            fontWeight: "bold",
                          }}
                        >
                          {service.service_title}
                        </h5>
                        <p
                          style={{
                            fontSize: "13.5px",
                            color: hoverIndex === index ? textGreyColor : textDarkColor,
                            textAlign: "justify",
                            lineHeight: "1.55",
                            marginBottom: "15px",
                          }}
                        >
                          {hoverIndex === index ? service.hoverText : service.defaultText}
                        </p>
                      </div>
                      <div className="d-flex align-items-center mt-auto">
                        <Link
                          to={`/services/${service.service_slug}`}
                          className="mb-0 fw-semibold text-decoration-none d-flex align-items-center gap-1"
                          style={{
                            color: hoverIndex === index ? textGreyColor : primaryColor,
                          }}
                        >
                          Know More
                          <ArrowRight
                            size={18}
                            style={{
                              transform:
                                hoverIndex === index
                                  ? "rotate(-30deg) translateZ(0)"
                                  : "rotate(0deg) translateZ(0)",
                              transition: "transform 0.4s ease-in-out",
                              color: hoverIndex === index ? textGreyColor : primaryColor,
                              willChange: "transform",
                            }}
                          />
                        </Link>
                      </div>
                    </Col>
                    <Col xs={4} className="d-flex align-items-center justify-content-center">
                      {service.headerImage && (
                        <Image
                          src={service.headerImage}
                          alt={service.service_title}
                          style={{
                            maxHeight: "85px",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Col xs={12} className="d-flex mb-3">
          <Button
            className="rounded-pill me-1 ms-auto"
            onClick={() => navigate("/services")}
            style={{
              backgroundColor: secondaryColor,
              color: textDarkColor,
              fontWeight: "600",
              border: "none",
            }}
          >
            View All Services →
          </Button>
        </Col>

        <GetInTouch />
      </Container>
    </section>
  );
};

export default ServicesSection;
